import './styles/tailwind.css';
import './styles/index.less';
import { createApp } from 'vue';
import App from './App.vue';
import router, { setupRouter } from './router';
import { setupStore } from '@/store';
import { useDialog } from '@/hooks/web/useDialog';
import { useMessage } from '@/hooks/web/useMessage';
import { useLoadingBar } from '@/hooks/web/useLoadingBar';
import { setupNaive, setupDirectives, setupMsalPlugin } from '@/plugins';

import { dropConsoleOutput } from './utils/log';

// drop all console output for production build
dropConsoleOutput(import.meta.env.PROD);

const message = useMessage();
const loadingBar = useLoadingBar();
const naiveDialog: any = useDialog();

async function bootstrap() {
  // const appProvider = createApp(AppProvider);

  const app = createApp(App);

  // register vue3 global error handler
  app.config.errorHandler = (err: any, vm, info) => {
    // 处理错误
    // `info` 是 Vue 特定的错误信息，比如错误所在的生命周期钩子
    console.log('>>> DEBUG: JS Error <<<\n', err);
    console.log('>>> DEBUG: Vue VM <<<\n', vm);
    console.log('>>> DEBUG: Vue Info <<<\n', info);
    naiveDialog.error({
      title: 'Oops!',
      content: err.message,
      positiveText: 'Close',
      maskClosable: false,
      closable: true,
      onPositiveClick: () => {},
    });

    loadingBar.error();
    message.destroyAll();
    naiveDialog.destroyAll();
  };

  // 注册全局常用的 naive-ui 组件
  setupNaive(app);

  // 注册全局自定义组件
  //setupCustomComponents();

  // 注册全局自定义指令，如：v-permission权限指令
  setupDirectives(app);

  // 注册全局方法，如：app.config.globalProperties.$message = message
  //setupGlobalMethods(app);

  // 注册全局 MsalPlugin
  setupMsalPlugin(app);

  // 挂载状态管理
  setupStore(app);

  // 挂载路由
  await setupRouter(app);

  // 路由准备就绪后挂载APP实例
  await router.isReady();

  // 动态的插入 meta 标签 会导致 ui框架样式 低于 tailwindcss 样式
  const meta = document.createElement('meta');
  meta.name = 'naive-ui-style';
  document.head.appendChild(meta);

  app.mount('#app', true);
}

void bootstrap();
